import { render } from "./LeaveSettings.vue?vue&type=template&id=783fe326"
import script from "./LeaveSettings.vue?vue&type=script&lang=js"
export * from "./LeaveSettings.vue?vue&type=script&lang=js"

import "./LeaveSettings.vue?vue&type=style&index=0&id=783fe326&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__